export default "https://housescan.app.solease.nl/static/media/charging_station.e7d1d343.svg";